module.exports = "/images/vendor/flag-icon-css/flags/1x1/sv.svg?26ee887282519008e13d35bd2ad362a8";